import { render, staticRenderFns } from "./AchievementDia.vue?vue&type=template&id=408d4813&scoped=true"
import script from "./AchievementDia.vue?vue&type=script&lang=js"
export * from "./AchievementDia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408d4813",
  null
  
)

export default component.exports